<template>
    <div class="VolunteerFamilyList">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h2><font-awesome-icon :icon="['fa', 'home']" /> Volunteer Families <span v-b-tooltip.hover title="Dispatch Hosting Request"><font-awesome-icon :icon="['fa', 'mobile-retro']" v-on:click="ShowDispatchHostingRequest()" class="olive-green-text pointer" /></span> <span v-b-tooltip.hover title="Add Family" style="float:right;"><font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddFamily()" class="olive-green-text pointer" /></span></h2>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <GenericDataTable ref="datatable"
                                      @recordclicked="OnRecordClicked"
                                      :table-fields="Fields"
                                      :data-filters="Filters"
                                      :table-slots="Slots"
                                      data-endpoint="StrongFamilies/VolunteerFamilies"
                                      data-method="GET"
                                      :load-indicator="true"
                                      :data-commit-name="null"
                                      :load-data-on-mounted="false" />
                </div>
            </div>
        </div>
        <DispatchHostingRequest ref="component-dispatch-hosting-request" />
        <NewVolunteerFamily ref="component-add-family" @updatetable="OnUpdateTable" />
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faMobileRetro } from '@fortawesome/free-solid-svg-icons';
    library.add(faMobileRetro);

    import GenericDataTable from '../../../Core/UI/GenericDataTable.vue';
    import NewVolunteerFamily from './NewVolunteerFamily.vue';
    import DispatchHostingRequest from './DispatchHostingRequest.vue';

    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        created() {
            //this.$store.commit("Clients.ClientProfiles.Clear");
            //this.$store.commit("Clients.ClientEnrollmentsList.Clear");
            EventBus.$on('global-update-initiated', this.OnUpdateTable);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
        },
        props: [],
        data: function () {
            return {
                //DATA TABLE CONFIGURATION
                Fields: [
                    {
                        name: '__slot:OpenProfile',
                        title: 'Name',
                        sortField: 'Name',
                    },
                    {
                        name: 'Name',
                        title: 'Name',
                        sortField: 'Name',
                        visible: false
                    },
                    {
                        name: 'FamilyType',
                        title: 'Type',
                        sortField: 'FamilyType',
                    },
                    {
                        name: 'SubProgramTerritoryName',
                        title: 'Territory',
                        sortField: 'SubProgramTerritoryName'
                    },
                    {
                        name: 'Location',
                        title: 'Location',
                        sortField: 'Location'
                    },
                    {
                        name: 'SpecialSkills',
                        title: 'Special Skills',
                        sortField: 'SpecialSkills'
                    },
                    {
                        name: 'Status',
                        title: "Status",
                        sortField: 'Status'
                    }
                ],
                Filters: [
                    {
                        Name: "Status",
                        Label: "Status",
                        Options: [
                            {
                                text: "All",
                                value: "All"
                            },
                            {
                                text: "Approved",
                                value: "Approved"
                            },
                            {
                                text: "Coordinator",
                                value: "Coordinator"
                            },
                            {
                                text: "In Training",
                                value: "In Training"
                            },
                            {
                                text: "No App Form",
                                value: "No App Form"
                            },
                            {
                                text: "No Roles",
                                value: "No Roles"
                            },
                            {
                                text: "On Hold",
                                value: "On Hold"
                            },
                            {
                                text: "RF Exclusive",
                                value: "RF Exclusive"
                            },
                            {
                                text: "Switched Off",
                                value: "Switched Off"
                            },
                            {
                                text: "Under 16",
                                value: "Under 16"
                            },
                        ],
                        Value: "Approved"
                    },
                    {
                        Name: "FamilyType",
                        Label: "Type",
                        Options: [
                            {
                                text: "All",
                                value: "All"
                            },
                            {
                                text: "Host Families",
                                value: "Host"
                            },
                            {
                                text: "Family Friends",
                                value: "Friend"
                            },
                            {
                                text: "Champions",
                                value: "Champion"
                            }
                        ],
                        Value: "Host"
                    },
                    {
                        Name: "SubProgramID",
                        Label: "Program",
                        Options: [

                        ],
                        Value: ""
                    },
                    {
                        Name: "SubProgramTerritoryID",
                        Label: "Territory",
                        Options: [

                        ],
                        Value: null
                    },
                ],
                Slots: [
                    {
                        Name: "OpenProfile",
                        DisplayProperty: "Name",
                        EventName: "recordclicked"
                    }
                ]
            };
        },
        methods: {
            //UI
            ShowDispatchHostingRequest() {
                this.$refs["component-dispatch-hosting-request"].ShowModal(this.$refs["datatable"].GetDataResult(), this.Filters);
            },
            ShowAddFamily() {
                this.$refs["component-add-family"].ShowModal();
            },
            OnUpdateTable() {
                this.$refs["datatable"].GetData();
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OnRecordClicked(rowData) {
                this.$store.commit("VolunteerFamilies.Profiles.Append", rowData);
                this.$parent.ChangePaneShown(rowData.Id);
            }
        },
        components: {
            GenericDataTable,
            NewVolunteerFamily,
            DispatchHostingRequest
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
        },
        mounted() {
            //Seed Sub Program Options
            if (this.SubProgramOptions.length > 0) {
                this.Filters[2].Value = this.SubProgramOptions[0].value;
            }
            this.Filters[2].Options = this.SubProgramOptions;

            //Seed SubProgram Territory Options
            this.Filters[3].Options = this.SubProgramTerritoryOptions;
            this.Filters[3].Options.push({ text: "All", value: null })

            this.OnUpdateTable();
        }
    }
</script>

<style scoped>
</style>